module.exports = __webpack_public_path__ + "static/media/vibino-feature-image grid-pic1.efc3e852.jpg";